import { render } from "./BlockEditShell.vue?vue&type=template&id=0ac75941&scoped=true"
import script from "./BlockEditShell.vue?vue&type=script&lang=js"
export * from "./BlockEditShell.vue?vue&type=script&lang=js"

import "./BlockEditShell.vue?vue&type=style&index=0&id=0ac75941&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ac75941"]])

export default __exports__